export { default } from "./ActivitiesReports.routes";
